import {actions} from '~utils/ngrx-util';
import {EntityDocumento} from '~entity/entity-documento/entity-documento.model';

const entityName = 'EntityDocumento';
const {add, adds, upsert, upserts, update, updates, remove, removes, load, clear} = actions<EntityDocumento>(entityName);

export const addEntityDocumento = add;
export const addEntityDocumentos = adds;
export const upsertEntityDocumento = upsert;
export const upsertEntityDocumentos = upserts;
export const updateEntityDocumento = update;
export const updateEntityDocumentos = updates;
export const deleteEntityDocumento = remove;
export const deleteEntityDocumentos = removes;
export const loadEntityDocumentos = load;
export const clearEntityDocumentos = clear;
